import React from "react";

function Footer() {
  return (
    <div className="flex items-center justify-center text-white bg-black h-[24px] text-[10px] fixed w-full bottom-0 z-50">
      &copy;Developed by Sefatullah Omar. All rights reserved - 2022.
    </div>
  );
}

export default Footer;
